import { ProgramId, TimetableId } from '@gyym/sdk'

import { encode } from '@/utils/encoder'

export const generateShortagePointPurchaseUrl = (
  programId: ProgramId,
  timetableId: TimetableId,
  retUrl: string,
) => {
  return `/me/points?purchaseShortage=${encode({
    programId,
    timetableId,
  })}&retUrl=${encodeURIComponent(retUrl)}`
}
